module.exports = __webpack_public_path__ + "static/media/premiumplan.db4e390e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/premiumplan.svg
// module id = 61
// module chunks = 0